// Lightweight field validators shared across the admin forms.

export const isValidEmail = (value: string): boolean =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim())

/** Returns an email error message, or null if valid. */
export const emailError = (value: string): string | null => {
  if (value.trim() === '') return 'Email is required'
  if (!isValidEmail(value)) return 'Enter a valid email address'
  return null
}

/** Returns a "required" error message, or null if present. */
export const requiredError = (
  value: string,
  label: string
): string | null => (value.trim() === '' ? `${label} is required` : null)

/** Returns a Meta ad account id error message, or null if valid. */
export const metaAdAccountIdError = (value: string): string | null => {
  const v = value.trim()
  if (v === '') return 'Meta Ad Account ID is required'
  if (!v.startsWith('act_')) return 'Must start with "act_" (e.g. act_123456789)'
  return null
}
